export default "__VITE_ASSET__CbIey1JB__"